import React from "react";
import { Link, useLocation, useHistory, Redirect } from "react-router-dom";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import { PageContainer } from "../Grid";
import { H1 } from "../TextStyles";
import { LargeButton } from "../Button";
import { WizardCard, WizardCardContainer } from "../WizardCard";
import upholsteredImage from "./biofit-builder-foundation-upholstered.png";
import nonUpholsteredImage from "./biofit-builder-foundation-non-upholstered.png";

const options = [
  {
    code: "upholstered",
    title: "Upholstered",
    description:
      "Choose from a selection of upholstery options to meet your needs for style and performance.",
    linkPath: "/series",
    image: upholsteredImage,
  },
  {
    code: "nonUpholstered",
    title: "Non-Upholstered",
    description:
      "If upholstered seating does not meet your performance or style specifications, we have solutions.",
    linkPath: "/series",
    image: nonUpholsteredImage,
  },
];

const Market = () => {
  const location = useLocation();
  const history = useHistory();

  const { market, style } = location.state || {};

  if (!market || !style) {
    return <Redirect to="/market" />;
  }
  if (location.state.market === "office") {
    history.replace("/series", { ...location.state, upholstered: "upholstered" });
  }
  return (
    <PageContainer>
      <Helmet>
        <title>Foundation</title>
      </Helmet>
      <H1>Foundation</H1>

      <Box width={1} my="2rem">
        Choose between an upholstered chair or non-upholstered chair.
      </Box>
      <WizardCardContainer>
        {options.map((option) => {
          const button = (
            <Link
              to={{
                pathname: option.linkPath,
                state: { ...location.state, upholstered: option.code },
              }}
            >
              <LargeButton secondary>Select {option.title}</LargeButton>
            </Link>
          );
          return (
            <WizardCard
              key={option.code}
              image={option.image}
              title={option.title}
              description={option.description}
              button={button}
            />
          );
        })}
      </WizardCardContainer>
    </PageContainer>
  );
};

export default Market;
